import {
  CampaignPerformanceAudienceItem,
  CampaignPerformanceAudiencesResponse,
  PerformanceAudienceDateRange,
  PerformanceAudienceFilterOption,
  PerformanceAudienceFilterOptions,
} from './types';

const AUDIENCE_ITEMS: CampaignPerformanceAudienceItem[] = [
  { id: '8a1c0b66-9d2b-4e1f-b0aa-3f7c9e1d4a51', externalId: 'a-clientifidelizzati', name: 'Clienti Fidelizzati' },
  { id: 'b2dd6e9f-7a16-4c4f-8d2c-66a8a93e9c2d', externalId: 'a-lookalikebestbuyers', name: 'Lookalike Best Buyers' },
  { id: 'c4441fb1-5832-4f9b-b88f-1c2b1d3d40ee', externalId: 'a-carrelloabbandonato', name: 'Carrello abbandonato 7gg' },
  { id: 'd8a3a51c-9b4e-4d22-a86b-5c8c5b04ab90', externalId: 'a-inattivi90gg', name: 'Inattivi 90 giorni' },
  { id: 'e5b8c9a0-3f47-4b1d-9c2a-7b5e8d4c2a13', externalId: 'a-leadwebinarq1', name: 'Lead webinar Q1' },
  { id: 'f6c9d0b1-2e36-4a0c-8b1f-9d4c7e3b1c02', externalId: 'a-visitatoripricing', name: 'Visitatori pricing page' },
];

export const AUDIENCE_USER_COUNTS: Record<string, number> = {
  '8a1c0b66-9d2b-4e1f-b0aa-3f7c9e1d4a51': 12_450,
  'b2dd6e9f-7a16-4c4f-8d2c-66a8a93e9c2d': 38_220,
  'c4441fb1-5832-4f9b-b88f-1c2b1d3d40ee': 4_180,
  'd8a3a51c-9b4e-4d22-a86b-5c8c5b04ab90': 21_030,
  'e5b8c9a0-3f47-4b1d-9c2a-7b5e8d4c2a13': 1_890,
  'f6c9d0b1-2e36-4a0c-8b1f-9d4c7e3b1c02': 7_620,
};

const GOOGLE_SCOPE_ITEMS = [
  { id: 'google-all', name: 'Tutti gli account Google', count: 3 },
  { id: 'google-enrico', name: 'Enrico Personal', count: 1 },
];

const META_SCOPE_ITEMS = [
  { id: 'meta-all', name: 'Tutti gli ad account Meta', count: 5 },
  { id: 'meta-polimo', name: 'Polimo Ads', count: 1 },
];

const STATIC_DATE_RANGES: PerformanceAudienceFilterOption[] = [
  { id: 'last_7_days', value: 'performanceAudience.filters.last_7_days' },
  { id: 'last_14_days', value: 'performanceAudience.filters.last_14_days' },
  { id: 'last_30_days', value: 'performanceAudience.filters.last_30_days' },
];

const toScopeFilterOption = (
  item: { id: string; name: string; count: number },
  platform: 'google' | 'meta'
): PerformanceAudienceFilterOption => {
  const accountLabel = platform === 'meta' ? 'ad account' : 'account';
  const suffix = `· ${item.count} ${accountLabel}`;

  return {
    id: item.id,
    value: item.name,
    suffix,
    menuLabel: `${item.name} ${suffix}`,
  };
};

export const MOCK_CAMPAIGN_PERFORMANCE_AUDIENCES: CampaignPerformanceAudiencesResponse = {
  audiences: AUDIENCE_ITEMS,
};

export const MOCK_CAMPAIGN_PERFORMANCE_SOURCES = {
  google: GOOGLE_SCOPE_ITEMS,
  meta: META_SCOPE_ITEMS,
};

export const MOCK_FILTER_OPTIONS: PerformanceAudienceFilterOptions = {
  audiences: AUDIENCE_ITEMS.map((item) => ({
    id: String(item.id),
    value: String(item.name),
    ...(item.externalId ? { externalId: item.externalId } : {}),
  })),
  googleScopes: GOOGLE_SCOPE_ITEMS.map((item) => toScopeFilterOption(item, 'google')),
  metaScopes: META_SCOPE_ITEMS.map((item) => toScopeFilterOption(item, 'meta')),
  dateRanges: STATIC_DATE_RANGES,
};

export const DEFAULT_FILTER_IDS = {
  audienceId: AUDIENCE_ITEMS[0]!.id!,
  googleScopeId: GOOGLE_SCOPE_ITEMS[0]!.id,
  metaScopeId: META_SCOPE_ITEMS[0]!.id,
  dateRange: 'last_7_days' as PerformanceAudienceDateRange,
};
